// extracted by mini-css-extract-plugin
export default {"root":"navigation_root__Myx4h"};